import { render } from "./SectionMenu.vue?vue&type=template&id=20d28477"
import script from "./SectionMenu.vue?vue&type=script&lang=js"
export * from "./SectionMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__